import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setDirtyState } from 'data/templates';
import { TemplateState } from 'data/templates/api';
import { fetchDocumentTemplateAction } from '../actions';
import { selectDocumentById } from '../selectors';
import { DocumentTemplate } from '../types';

export const useDocumentById = (
  docId: number,
  refetch?: boolean,
): DocumentTemplate => {
  const dispatch = useDispatch();
  const document: DocumentTemplate = useSelector(selectDocumentById(docId));

  useEffect(() => {
    if (refetch) {
      dispatch(fetchDocumentTemplateAction({ templateId: docId }));
    }
  }, [docId, dispatch, refetch]);

  useEffect(() => {
    if (document?.state === TemplateState.Draft) {
      dispatch(
        setDirtyState({
          id: docId,
        }),
      );
    }
  }, [dispatch, docId, document]);

  return document;
};
